import { connect } from 'react-redux';
import type { RootState } from 'reducers/types';
import { getRecipientName } from 'selectors/entities/recipient/recipient';
import { getInvalidParamErrors } from 'selectors/errors/errors';
import { FetchOffersError as FetchOffersErrorComponent } from './FetchOffersError';

const mapStateToProps = (state: RootState) => ({
  errors: getInvalidParamErrors(state),
  recipientName: getRecipientName(state),
});

export const FetchOffersError = connect(mapStateToProps)(
  FetchOffersErrorComponent,
);
